/**
 * This class contains helper functions to work with strings 
 * @dynamic
 */
export class StringHelpers {

    /**
     * Function that receives a string, converts it to lowercase and replaces spaces with '_'
     * @param value string to be converted 
     * @returns 
     */
    public static convertToFileFormat(value: string): string {
        return value.toLowerCase().replace(/ /g, '_');
    }

    /**
     * Validates if the string contains at least one number
     * @param value string to be validated
     * @returns
     * true if the string contains at least one number
     * false if the string does not contain any number
     */
    public static validateStringHasNumber(value: string) {
        let pattern = /[0-9]+/;
        return pattern.test(value);
    }
}